import React, { createContext, useState } from 'react';

export const AnimationContext = createContext();

export const AnimationProvider = ({ children }) => {
  const [hasAnimatedQuestion, setHasAnimatedQuestion] = useState(false);

  return (
    <AnimationContext.Provider value={{ hasAnimatedQuestion, setHasAnimatedQuestion }}>
      {children}
    </AnimationContext.Provider>
  );
};